import React, { useEffect, useRef, useState } from 'react'
import Layout from '../components/Layout'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { api } from '../helper/api';
import { IPFStoURL, formatPrice, getCurrentChain, getSaleCurrencyImg, trimAddress } from '../helper/functions';
import { Accordion } from "react-bootstrap";
import { CHAIN_INFO, DEFAULT_IMAGES } from '../helper/constant';
import CreateSaleModal from '../components/CreateSaleModal';
import { useAccount } from 'wagmi';
import BuyNowModal from '../components/BuyNowModal';
import { useCreateSaleStats } from '../stats/useUserInfo';
import { ConnectWallet } from '../components/ConnectWallet';

export default function NFTInfo() {
    const { address } = useAccount();
    const [nftData, setNftData] = useState([]);
    const [metadata, setMetadata] = useState([]);
    const [openOrder, setOpenOrder] = useState([]);
    const [tokenHistory, setTokenHistory] = useState([]);
    const { nftaddress, tokenId } = useParams();
    const count = useRef(0);
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const { chainId } = useAccount();
    const currentChain = getCurrentChain(chainId);
    const [buyData, setBuyData] = useState([]);
    const [bidData, setBidData] = useState([]);
    const [buyModal, setBuyModal] = useState(false)
    const [updater, setUpdater] = useState(1)
    const stats = useCreateSaleStats(nftData.type, nftData.nft_address, nftData.tokenId, updater);
    const description = metadata?.description || "";

    const minPriceRecord = openOrder && openOrder.length > 0 && openOrder.reduce((min, record) => {
        return parseInt(record.price) < parseInt(min.price) ? record : min;
    });

    useEffect(() => {
        async function fetch() {
            let dataNft = await api.get(`nft/${nftaddress}/${tokenId}`)
            if (dataNft && dataNft.data && dataNft.data.error === 'OK' && dataNft.data.data[0]) {
                console.log(dataNft.data.data[0])
                setNftData(dataNft.data.data[0])
                setMetadata(dataNft.data.data[0].metaData ? JSON.parse(dataNft.data.data[0].metaData) : '')
                setOpenOrder(dataNft.data.openOrder)
                setTokenHistory(dataNft.data.tokenHistory)
            }
            else {
                navigate('/');
            }
        }

        if (nftaddress && tokenId && count.current === 0) {
            count.current = 1;
            fetch();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nftaddress, tokenId]);

    useEffect(() => {
        async function fetch() {
            let dataNft = await api.get(`nft/nft-bids`, {
                params: {
                    nft_address: nftaddress,
                    tokenId: tokenId
                }
            })
            if (dataNft && dataNft.data && dataNft.data.error === 'OK' && dataNft.data.data[0]) {
                setBidData(dataNft.data.data)
            }
        }

        if (nftaddress && tokenId) {
            fetch();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nftaddress, tokenId]);

    const isHTML = (str) => {
        const doc = new DOMParser().parseFromString(str, "text/html");
        return Array.from(doc.body.childNodes).some(node => node.nodeType === 1); // Checks if there's an HTML element
    };


    return (
        <Layout>
            <div class="no-bottom no-top" id="content">
                <div id="top"></div>
                {nftData &&
                    <>
                        <section id="nft-item-details" aria-label="section" class="sm-mt-0">
                            <div class="container">
                                <div class="row g-5">
                                    <div class="col-md-6">
                                        <div class="nft-image-wrapper">
                                            {metadata && metadata.animation_url ? (
                                                <video
                                                    src={IPFStoURL(metadata?.['animation_url'])}
                                                    className="image-autosize img-fluid img-rounded mb-sm-30"
                                                    alt="profile"
                                                    controls // Enables play, pause, volume, etc.
                                                    autoPlay // Auto-play the video when loaded
                                                    loop // Loops the video playback
                                                    muted // Start muted for autoplay compatibility
                                                    playsInline // Improves playback performance on mobile
                                                    preload="metadata" // Preload only metadata for faster page load
                                                >
                                                    Your browser does not support the video tag.
                                                </video>
                                            ) : (
                                                <img
                                                    src={IPFStoURL(metadata?.['image'])}
                                                    className="image-autosize img-fluid img-rounded mb-sm-30"
                                                    alt="profile"
                                                />
                                            )}

                                        </div>
                                        <div className='mt-5'>
                                            <Accordion defaultActiveKey={0}>
                                                <Accordion.Item eventKey="0">
                                                    <Accordion.Header>
                                                        <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><line x1="17" y1="10" x2="3" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="17" y1="18" x2="3" y2="18"></line></svg>
                                                        <span className='mx-2'>Description</span>
                                                    </Accordion.Header>
                                                    <Accordion.Body>
                                                        <div className="description">
                                                            {isHTML(description) ? (
                                                                // Render as HTML if it contains HTML tags
                                                                <div dangerouslySetInnerHTML={{ __html: description }} />
                                                            ) : (
                                                                // Otherwise, render as plain text with formatting
                                                                description
                                                                    .split("\r\n\r\n") // Split double line breaks for paragraphs
                                                                    .map((paragraph, index) => (
                                                                        <p key={index} className="text-start">
                                                                            {paragraph.split("\r\n").map((line, i) => (
                                                                                <React.Fragment key={i}>
                                                                                    {line}
                                                                                    <br />
                                                                                </React.Fragment>
                                                                            ))}
                                                                        </p>
                                                                    ))
                                                            )}
                                                        </div>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                                <Accordion.Item eventKey="1">
                                                    <Accordion.Header>
                                                        <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline></svg>
                                                        <span className='mx-2'>Traits</span>
                                                    </Accordion.Header>
                                                    <Accordion.Body>
                                                        <div class="de_tab_content">
                                                            <div class="row gx-2">
                                                                {metadata && metadata.attributes && metadata.attributes.length > 0 && metadata.attributes.map((items, key) => {
                                                                    return (
                                                                        <div class="col-lg-4 col-md-6 col-sm-6" key={key}>
                                                                            <a href="#sec" class="nft_attr">
                                                                                <h5>{items?.trait_type}</h5>
                                                                                <h4>{items?.value}</h4>
                                                                            </a>
                                                                        </div>
                                                                    )
                                                                })}


                                                            </div>
                                                        </div>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                                <Accordion.Item eventKey="2">
                                                    <Accordion.Header>
                                                        <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path><polygon points="12 15 17 21 7 21 12 15"></polygon></svg>
                                                        <span className='mx-2'>Details</span>
                                                    </Accordion.Header>
                                                    <Accordion.Body>
                                                        <div className='d-flex justify-content-between mb-1'>
                                                            <div>Contract Address</div>
                                                            <div>{nftData && nftData.nft_address ? trimAddress(nftData.nft_address) : ''}</div>
                                                        </div>
                                                        <div className='d-flex justify-content-between mb-1'>
                                                            <div>Token ID</div>
                                                            <div>{nftData && nftData.tokenId ? nftData.tokenId : ''}</div>
                                                        </div>
                                                        <div className='d-flex justify-content-between mb-1'>
                                                            <div>Token Standard</div>
                                                            <div>{nftData && nftData.type ? nftData.type : ''}</div>
                                                        </div>
                                                        <div className='d-flex justify-content-between mb-1'>
                                                            <div>Chain</div>
                                                            <div>{nftData && nftData.chain_id ? CHAIN_INFO[getCurrentChain(nftData?.chain_id)].name : ''}</div>
                                                        </div>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            </Accordion>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="item_info">
                                            <h2>{metadata?.['name']}</h2>
                                            <div class="item_info_counts">
                                                <div class="item_info_views"><i class="fa fa-indent"></i>{nftData?.total_nft}</div>
                                                {/* <div class="item_info_like"><i class="fa fa-heart"></i>18</div> */}
                                            </div>
                                            <div className='row'>
                                                <div className='col-6'>
                                                    <div class="d-flex align-items-center user-profile">
                                                        <div class="image mx-2">
                                                            <img src={nftData.user_profile ? IPFStoURL(nftData.user_profile) : IPFStoURL(DEFAULT_IMAGES.profile.profile)} alt='profile' class="rounded" width="24px" height="24px" />
                                                        </div>
                                                        <div class="ml-3 w-100">
                                                            <h5>Owner</h5>
                                                            <h6 class="mb-0 mt-0">{nftData.username ? nftData.username : trimAddress(nftData.owner)}</h6>
                                                            <span>{nftData.owner ? trimAddress(nftData.owner) : '- -'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-6'>
                                                    <div class="d-flex align-items-center user-profile">
                                                        <div class="image mx-2">
                                                            <img src={nftData.col_profile ? IPFStoURL(nftData?.col_profile) : IPFStoURL(DEFAULT_IMAGES.collection.profile)} class="rounded" alt='profile' width="24px" height="24px" />
                                                        </div>
                                                        <div class="ml-3 w-100">
                                                            <Link to={`/collection/${nftData.nft_address}`}>
                                                                <h5>Collection</h5>
                                                                <h6 class="mb-0 mt-0">{nftData?.name}</h6>
                                                                <h6 class="mb-0 mt-0">
                                                                    {nftData.nft_address ? trimAddress(nftData.nft_address) : ''}
                                                                </h6>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="spacer-40"></div>



                                            <div class="de_tab tab_simple">
                                                {minPriceRecord && address && (
                                                    <>
                                                        <h6>Current Price</h6>
                                                        <div class="nft-item-price">
                                                            <img src={getSaleCurrencyImg(minPriceRecord.ERC20Token, currentChain)} alt="ethereum" />
                                                            <span>{minPriceRecord && minPriceRecord.nftHighestBid > 0 ? formatPrice(minPriceRecord.nftHighestBid / Math.pow(10, 18)) : minPriceRecord && minPriceRecord.price ? formatPrice(minPriceRecord.price / Math.pow(10, 18)) : ' - '}</span>
                                                            <p>Listed By {minPriceRecord?.username}</p>
                                                        </div>
                                                        {minPriceRecord.nftSeller && address && minPriceRecord.nftSeller.toLowerCase() === address.toLowerCase() ? (
                                                            <button type='button' onClick={() => {
                                                                setBuyData(minPriceRecord);
                                                                setBuyModal(true)
                                                            }} class="btn-main btn-lg btn-light mx-1">
                                                                Cancel Sale
                                                            </button>
                                                        ) : (
                                                            <button type='button' onClick={() => {
                                                                setBuyData(minPriceRecord);
                                                                setBuyModal(true)
                                                            }} class="btn-main btn-lg btn-light mx-1">
                                                                {minPriceRecord.saletype === '2' ? 'Place Bid' : 'Buy Now'}
                                                            </button>
                                                        )}
                                                    </>
                                                )}

                                                {address ? (
                                                    address && stats.balance > 0 &&
                                                    <button type='button' onClick={() => setShow(true)} class="btn-main btn-lg btn-light">
                                                        Create Sale
                                                    </button>


                                                ) : (
                                                    <ConnectWallet />
                                                )}
                                            </div>






                                            <div class="spacer-40"></div>
                                            <Accordion defaultActiveKey="5">
                                                <Accordion.Item eventKey="5">
                                                    <Accordion.Header>
                                                        <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><line x1="17" y1="10" x2="3" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="17" y1="18" x2="3" y2="18"></line></svg>
                                                        <span className='mx-2'>Listings</span>
                                                    </Accordion.Header>
                                                    <Accordion.Body>
                                                        <table class="table de-table table-responsive">
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col">Listed By</th>
                                                                    <th scope="col">saletype</th>
                                                                    <th scope="col">price</th>
                                                                    <th scope="col">EndTime</th>
                                                                    <th scope="col">Qty</th>
                                                                    <th scope="col">Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {openOrder && openOrder.length > 0 ? (
                                                                    openOrder.map((items, key) => {
                                                                        let currencyInfo = CHAIN_INFO[currentChain].currency_support.filter((values) => items.ERC20Token && values.address.toLowerCase() === items.ERC20Token.toLowerCase())
                                                                        items.currencyInfo = currencyInfo.length > 0 ? currencyInfo[0] : CHAIN_INFO[currentChain].currency_support[0];

                                                                        return (
                                                                            <tr key={key}>
                                                                                <td>
                                                                                    {items?.username}
                                                                                </td>
                                                                                <td>
                                                                                    {items.saletype === "1" ? "Sale" : "Auction"}
                                                                                </td>
                                                                                <td>{items.nftHighestBid && items.nftHighestBid > 0 ? formatPrice(items.nftHighestBid / Math.pow(10, 18)) : items.price ? formatPrice(items.price / Math.pow(10, 18)) : 0} {items.currencyInfo.symbol}</td>
                                                                                <td>{items.auctionEnd > 0 ? new Date(items.auctionEnd * 1000).toLocaleDateString() : ' - '}</td>
                                                                                <td>{items.left_amount ? formatPrice(items.left_amount) : 0}</td>
                                                                                <td>
                                                                                    <button type='button' onClick={() => {
                                                                                        setBuyData(items);
                                                                                        setBuyModal(true)
                                                                                    }} className='btn btn-link' >
                                                                                        <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={6}>No listings yet</td>
                                                                    </tr>
                                                                )}

                                                            </tbody>
                                                        </table>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            </Accordion>
                                            {bidData && bidData.length > 0 &&
                                                <>
                                                    <div class="spacer-40"></div>
                                                    <Accordion defaultActiveKey="5">
                                                        <Accordion.Item eventKey="5">
                                                            <Accordion.Header>
                                                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><line x1="17" y1="10" x2="3" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="17" y1="18" x2="3" y2="18"></line></svg>
                                                                <span className='mx-2'>Recent Bids</span>
                                                            </Accordion.Header>
                                                            <Accordion.Body>
                                                                <table class="table de-table table-responsive">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col">Username</th>
                                                                            <th scope="col">Price</th>
                                                                            <th scope="col">Qty</th>
                                                                            <th scope="col">From</th>
                                                                            <th scope="col">Date</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {bidData && bidData.length > 0 ? (
                                                                            bidData.map((items, key) => {
                                                                                return (
                                                                                    <tr key={key}>
                                                                                        <td>
                                                                                            {items.username ? items.username : trimAddress(items.nftHighestBidder)}
                                                                                        </td>
                                                                                        <td>
                                                                                            {formatPrice(items.nftHighestBid / Math.pow(10, 18))} BST
                                                                                        </td>
                                                                                        <td>
                                                                                            {items.amount}
                                                                                        </td>
                                                                                        <td>{trimAddress(items.nftHighestBidder)}</td>
                                                                                        <td>
                                                                                            <span className='mx-1'>{items.created ? new Date(items.created).toLocaleDateString() : ' - '}</span>
                                                                                            <a target='_blank' rel="noreferrer" href={`${CHAIN_INFO[currentChain].explorer}/tx/${items.tx_hash}`}>
                                                                                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>
                                                                                            </a>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        ) : (
                                                                            <tr>
                                                                                <td colSpan={6}>No listings yet</td>
                                                                            </tr>
                                                                        )}

                                                                    </tbody>
                                                                </table>
                                                            </Accordion.Body>
                                                        </Accordion.Item>
                                                    </Accordion>
                                                </>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <div class="container">
                            <Accordion defaultActiveKey="4">
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>
                                        <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><line x1="17" y1="10" x2="3" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="17" y1="18" x2="3" y2="18"></line></svg>
                                        <span className='mx-2'>Transaction History</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <table class="table de-table table-responsive">
                                            <thead>
                                                <tr>
                                                    <th scope="col">Event</th>
                                                    <th scope="col">Quantity</th>
                                                    <th scope="col">From</th>
                                                    <th scope="col">To</th>
                                                    <th scope="col">Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {tokenHistory && tokenHistory.length > 0 ? (
                                                    tokenHistory.map((items, key) => {
                                                        return (
                                                            <tr key={key}>
                                                                <td>
                                                                    {items.sender === "0x0000000000000000000000000000000000000000" ? "Minted" : "Transfer"}
                                                                </td>
                                                                <td>{items.amount ? items.amount : 0}</td>
                                                                <td>{items.sender ? trimAddress(items.sender) : ' - '}</td>
                                                                <td>{items.owner ? trimAddress(items.owner) : 0}</td>
                                                                <td>
                                                                    <span className='mx-1'>{items.created ? new Date(items.created).toLocaleDateString() : ' - '}</span>
                                                                    <a target='_blank' rel="noreferrer" href={`${CHAIN_INFO[currentChain].explorer}/tx/${items.tokenHash}`}>
                                                                        <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={6}>No History Found</td>
                                                    </tr>
                                                )}

                                            </tbody>
                                        </table>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </>
                }
            </div>
            <CreateSaleModal setUpdater={setUpdater} stats={stats} show={show} setShow={setShow} nftData={nftData} metadata={metadata} />
            <BuyNowModal metadata={metadata} buyData={buyData} buyModal={buyModal} setBuyModal={setBuyModal} nftData={nftData} />
        </Layout >

    )
}
